<div class="pdf-container" 
     [ngClass]="{
       'slide-next': isTransitioning && slideDirection === 'next', 
       'slide-prev': isTransitioning && slideDirection === 'prev',
       'transitioning': isTransitioning
     }">
    <pdf-viewer 
    [src]="pdfSrc" 
    [render-text]="true" 
    [fit-to-page]="true"
    [autoresize]="true" 
    [show-all]="false"
    [page]="page"
    (after-load-complete)="onPdfLoaded($event)"
    (click)="onSave()">
    </pdf-viewer>
</div>